module.exports = __webpack_public_path__ + "img/rule-btn2.75e5fa5a.png";